export const AdminSidebarData = [
  {
    title: "AGE GROUP",
    icon: "",
    subMenu: [
      {
        title: "Create Age Group",
        path: "ageGroup",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Edit/Delete Age Group",
        path: "editDeleteAgeGroup",
        cName: "sub-nav",
        icon: "",
      },
    ],
  },

  {
    title: "PRODUCT TYPE",
    icon: "",
    subMenu: [
      {
        title: "Create Product Type ",
        path: "createProductType",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Edit/Delete Product Type",
        path: "editDeleteProductType",
        cName: "sub-nav",
        icon: "",
      },
    ],
  },
  {
    title: "CATEGORY ",
    icon: "",
    subMenu: [
      {
        title: "Create Category ",
        path: "createCategory",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Edit/Delete Category",
        path: "editDeleteCategory",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Add Category Video",
        path: "addCategoryVidoes",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Edit Delete Category Video",
        path: "editDeleteCategoryVideos",
        cName: "sub-nav",
        icon: "",
      },
    ],
  },
  // {
  //     title: "SUB CATEGORY",
  //     icon: "",
  //     subMenu: [
  //         {
  //             title: "Add Sub Category",
  //             path: "addSubCategory",
  //             cName: "sub-nav",
  //             icon: "",
  //         },
  //         {
  //             title: "Edit / Delete Sub Category",
  //             path: "editDeleteSubCategory",
  //             cName: "sub-nav",
  //             icon: "",
  //         },
  //     ],
  // },
  {
    title: "TAG OPTION",
    icon: "",
    subMenu: [
      {
        title: "Add Tag Option",
        path: "addTagOption",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Edit/Delete Tag Option",
        path: "editDeleteTagOption",
        cName: "sub-nav",
        icon: "",
      },
    ],
  },
  {
    title: "PRODUCT",
    icon: "",
    subMenu: [
      {
        title: "Add Product",
        path: "addProduct",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Edit/Delete Product",
        path: "editDeleteProduct",
        cName: "sub-nav",
        icon: "",
      },
    ],
  },
  {
    title: "AUTHOR",
    icon: "",
    subMenu: [
      {
        title: "Create Author",
        path: "createAuthor",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Edit/Delete Author",
        path: "editDeleteAuthor",
        cName: "sub-nav",
        icon: "",
      },
    ],
  },
  {
    title: "BLOG",
    icon: "",
    subMenu: [
      {
        title: "Create Blog",
        path: "createBlog",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Edit/Delete Blog",
        path: "editDeleteBlog",
        cName: "sub-nav",
        icon: "",
      },
    ],
  },

  // {
  //     title: "DEPARTMENT",
  //     icon: "",
  //     subMenu: [
  //         {
  //             title: "Add Department",
  //             path: "addDepartment",
  //             cName: "sub-nav",
  //             icon: "",
  //         },
  //         {
  //             title: "Edit / Delete Department",
  //             path: "editDeleteDepartment",
  //             cName: "sub-nav",
  //             icon: "",
  //         },
  //     ],
  // },

  {
    title: "BASE OFFER",
    icon: "",
    subMenu: [
      {
        title: "Create Base Offer",
        path: "createBaseOffer",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Edit/Delete Base Offer",
        path: "editDeleteBaseOffer",
        cName: "sub-nav",
        icon: "",
      },
    ],
  },
  {
    title: "COUPON CODE",
    icon: "",
    subMenu: [
      {
        title: "Create Coupon Code",
        path: "createCouponCode",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Edit/Delete Coupon Code",
        path: "editDeleteCouponCode",
        cName: "sub-nav",
        icon: "",
      },
    ],
  },
  {
    title: "USER CREATION",
    link: "createUser",
  },
  // {
  //   title: "DISPATCH ORDER",
  //   link: "dispatchOrder",
  // },
];
